import { createRoot } from 'react-dom/client';
import CameraCapture from './CameraCapture';

// The camera survives the chooser closing, and owns its stream until dismissed.
export function openCameraCapture({ onCapture, initialFacingMode = 'environment' }) {
  const host = document.createElement('div');
  document.body.appendChild(host);
  const root = createRoot(host);
  const close = () => {
    root.unmount();
    host.remove();
  };
  root.render(<CameraCapture open onCapture={onCapture} onClose={close} initialFacingMode={initialFacingMode} />);
}
